import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, reactive, ref, watch } from 'vue';
import { Popup, Cascader, CascaderOption } from 'vant';
import { getArea } from "@/api/area"
interface IProp {
    show?: boolean;
    text?: string;
    title?: string;
    textField?: string;
    valueField?: string;
    childrenField?: string;
    level?: 1 | 2 | 3;
    proviceId?: number;
    cityId?: number;
    areaId?: number;
    symbol?: string;
    optional?: boolean;
    optionalText?: string;
    optionalValue?: string | number
}
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: Boolean, default: false },
    text: { default: "" },
    title: { default: "请选择" },
    textField: { default: "areaName" },
    valueField: { default: "id" },
    childrenField: { default: "children" },
    level: { default: 3 },
    proviceId: { default: 0 },
    cityId: { default: 0 },
    areaId: { default: 0 },
    symbol: { default: "/" },
    optional: { type: Boolean, default: false },
    optionalText: { default: '无' },
    optionalValue: { default: 0 }
  },
  emits: ["update:show", "update:text", "update:proviceId", "update:cityId", "update:areaId", "selected"],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, text: string, title: string, textField: string, valueField: string, childrenField: string, level: 1 | 2 | 3, proviceId: number, cityId: number, areaId: number, symbol: string, optional: boolean, optionalText: string, optionalValue: string | number }



// eslint-disable-next-line no-undef

const fieldNames = reactive({
    text: props.textField,
    value: props.valueField,
    children: props.childrenField
})
const popupShow = ref<boolean>(props.show);
watch(() => props.show, (v: boolean) => {
    popupShow.value = v;
})
watch(() => props.proviceId, (newVal, oldVal) => {
    if (oldVal && !newVal) {
        //清空
        cascaderValue.value = 0
    }
});
const onPopupClosed = () => {
    emits("update:show", false)
}
const options = ref<CascaderOption[]>([]);
const initData = async () => {
    let areas = await getArea();

    if (areas && areas.length) {
        areas.forEach(item => {
            if (item.id == 350000) {
                item.sort = 1;
            }
            if (item.id == 320000) {
                item.sort = 2;
            }
            if (item.id == 510000) {
                item.sort = 3;
            }
        });
        let firstArea = areas.filter(item => {
            return item.id == 350000 || item.id == 510000 || item.id == 320000;
        });
        firstArea.sort((prv, next) => {
            return prv.sort - next.sort;
        });

        const provincesData = areas.filter(item => {
            return item.id != 350000 && item.id != 510000 && item.id != 320000;
        });
        areas = firstArea.concat(provincesData);
        options.value = areas.map(a => {
            const item = { ...a };
            if (props.level > 1) {
                item[props.childrenField] = []
            }
            return item;
        });
        if (props.proviceId) {
            let proviceNode = options.value.find(o => o[props.valueField] == props.proviceId);
            let labelText = proviceNode[props.textField];
            if (props.level > 1) {
                await getChildren(proviceNode, props.proviceId, 2);
                let cityNode = proviceNode[props.childrenField].find(o => o[props.valueField] == props.cityId);
                if (cityNode) {
                    labelText += props.symbol + cityNode[props.textField];
                }
                if (props.level > 2) {
                    await getChildren(cityNode, props.cityId, 3);
                    let areaNode = cityNode[props.childrenField].find(o => o[props.valueField] == props.areaId);
                    if (areaNode) {
                        labelText += props.symbol + areaNode[props.textField];
                    }
                }
            }
            emits("update:text", labelText);
        }
        if (props.level === 3 && props.areaId) {
            cascaderValue.value = props.areaId
        }
        if (props.level === 2 && props.cityId) {
            cascaderValue.value = props.cityId
        }
        if (props.level === 1 && props.proviceId) {
            cascaderValue.value = props.proviceId
        }
    }
}
const getChildren = async (parentNode, parentValue, current) => {
    let areas = await getArea(parentValue);
    if (areas && areas.length) {
        parentNode[props.childrenField] = areas.map(a => {
            const item = { ...a };
            if (current < props.level) {
                item[props.childrenField] = []
            }
            return item;
        });
    }
}
const cascaderValue = ref<number>(0);
const onCascaderClose = () => {
    popupShow.value = false;
    emits("update:show", false)
}
const onChange = async ({ value, selectedOptions }) => {
    if (props.level > selectedOptions.length) {
        let areas = await getArea(value);
        if (areas && areas.length) {
            selectedOptions[selectedOptions.length - 1][props.childrenField] = areas.map(a => {
                const item = { ...a };
                if (selectedOptions.length + 1 < props.level) {
                    item[props.childrenField] = []
                }
                return item;
            });
        }
    }
}
const clear = () => {
    if(!props.optional) return;
    popupShow.value = false;
    cascaderValue.value = 0;
    emits("update:show", false)
    emits("update:text", "");
    emits("update:proviceId", props.optionalValue);
    emits("update:cityId", props.optionalValue);
    emits("update:areaId", props.optionalValue);
    emits("selected", [{ [props.valueField]: props.optionalValue, [props.textField]: '' }]);
}
const onFinish = ({ selectedOptions }) => {
    popupShow.value = false;
    emits("update:show", false)
    const text = selectedOptions.filter((o, index) => index < props.level).map((option) => option[props.textField]).join(props.symbol);
    emits("update:text", text);
    const values = selectedOptions.map((option) => option[props.valueField]);

    emits("update:proviceId", values && values[0]);
    emits("update:cityId", props.level > 1 ? (values && values[1]) : null);
    emits("update:areaId", props.level > 2 ? (values && values[2]) : null);
    emits("selected", values);
}
//层级改变重新加载数据
watch(() => props.level, async () => {
    await initData();
})

onBeforeMount(async () => {
    await initData();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: popupShow.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((popupShow).value = $event)),
    round: "",
    position: "bottom",
    onClosed: onPopupClosed
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Cascader), {
        modelValue: cascaderValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cascaderValue).value = $event)),
        title: __props.title,
        options: options.value,
        "field-names": _unref(fieldNames),
        "active-color": "#157CFF",
        onClose: onCascaderClose,
        onChange: onChange,
        onFinish: onFinish
      }, _createSlots({ _: 2 }, [
        (props.optional)
          ? {
              name: "options-top",
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: "clear-btn",
                  onClick: clear
                }, _toDisplayString(props.optionalText), 1)
              ])
            }
          : undefined
      ]), 1032, ["modelValue", "title", "options", "field-names"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})